import { ApplicationRef, Component, HostBinding } from "@angular/core";
import { HubConnection, HubConnectionState } from "@microsoft/signalr";
import { Subscription } from "rxjs";
import { AuthenticationService, SignalRService } from "./_services";
import { TitleService } from "./_services/title.service";
import { AppState } from "./state/app.state";
import { ResponsiveHelper } from "./_helpers/responsive";
import { debounceTime } from "rxjs/operators";
import { NavigationCancel, NavigationEnd, NavigationError, Router } from "@angular/router";
import { NavigationErrorHandler } from "./_helpers/navigation-error-handler";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent {
  title = "Lexi Market";

  public isLoading = true;
  public isInitialized = false;

  private _hubConnection: HubConnection;
  private _signalRSubscription: Subscription;
  private _jwtSubscription: Subscription;
  private _lastTenantId: string;

  @HostBinding('class.no-transition') public get disableTransition() {
    return !this.isInitialized;
  }

  public constructor(
    private _state: AppState,
    private _ar: ApplicationRef,
    private _titleService: TitleService,
    private _signalRService: SignalRService,
    private _authService: AuthenticationService,
    private _responsive: ResponsiveHelper,
    private _router: Router,
    private _navigationErrorHandler: NavigationErrorHandler
  ) {
    this._titleService.setTitle(this.title);

    // Hide page loader after initial navigation completes or fails
    let sub = this._router.events.subscribe((event) => {
      if (
        event instanceof NavigationEnd ||
        event instanceof NavigationCancel ||
        event instanceof NavigationError
      ) {
        this.isLoading = false;
        sub.unsubscribe();
        setTimeout(_ => {
          this.isInitialized = true;
        })
      }
    });
  }

  public ngOnInit() {
    this._jwtSubscription = this._authService.jwt.subscribe((x) => {
      if (!x) {
        this._leaveTenant(this._lastTenantId);
        return;
      }

      this._joinTenant(x.CurrentTenantId);
    });

    // this._state.updateApplicationSubject$
    //   .pipe(debounceTime(50))
    //   .subscribe((val) => {
    //     this._responsive.getLayout();
    //     this._ar.tick();
    //   });

    this._responsive.getLayout();
    window.onresize = () => {
      this._responsive.getLayout();
    };
  }

  public ngOnDestroy() {
    if (this._jwtSubscription) {
      this._jwtSubscription.unsubscribe();
    }
    this._leaveTenant(this._lastTenantId);
  }
  private _joinTenant(tenantId: string) {
    this._lastTenantId = tenantId;
    this._signalRSubscription = this._signalRService.commonHub.subscribe(
      (connection) => {
        if (
          this._signalRService.isHubConnected(connection) &&
          this._authService.isLoggedIn
        ) {
          this._hubConnection = connection;
          connection.send("joinTenant");
        }
      }
    );
  }

  private _leaveTenant(tenantId: string) {
    if (!tenantId) {
      return;
    }

    if (this._signalRService.isHubConnected(this._hubConnection)) {
      this._hubConnection.send("leaveTenant", tenantId);
    }

    if (this._signalRSubscription) {
      this._signalRSubscription.unsubscribe();
    }
  }

}
